import ProjectConfigPage from './ProjectConfigPage'

export default ProjectConfigPage
